import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Input, Button } from "reactstrap";
function AssetsgalleryImges(props) {

  // const handleReplaceImages = (img) => {
  //   props.setSelectedImages(img)
  // }
  const handleReplaceImages = (img) => {
    if (props.selectedImages && props.selectedImages.fileId === img.fileId) {
      props.setSelectedImages(null);
      if (props.onUnselect) props.onUnselect();
    } else {
      props.setSelectedImages(img);
    }
  }
  
  return (
    <>
      <div className='d-flex justify-content-end mb-2' >
        <Button
          className='mr-1 btn-background-color'
          disabled={!props.selectedImages || !props.selectedImages.fileId}
          onClick={() => props.handleSubmitFile()}>
          Replace
        </Button>
        {/* <Button onClick={() => handleUpdateFiles()}>
                Add Images
              </Button> */}
      </div>
      <Row className='p-1'>
      {props.loading ? (
          <Col xs={12}>
            <div className="text-center py-5">
              <h5>Loading Images...</h5>
            </div>
          </Col>
        ) : props.galleryImg && props.galleryImg.length > 0 ? (
          props.galleryImg && props.galleryImg.map((asset) => (
            <Col sm={4} md={3} key={asset.fileId}>
  {(() => {
    const isSelected = props.selectedImages && props.selectedImages.fileId === asset.fileId;
    return (
      <Card
        onClick={() => handleReplaceImages(asset)}
        style={{
          border: isSelected ? "2px solid #007bff" : "1px solid #ddd",
          cursor: "pointer",
          position: "relative",
          transition: "border 0.2s",
        }}
      >
        {/* Checkmark Badge */}
        {isSelected && (
          <div style={{
            position: "absolute",
            top: 6,
            right: 6,
            width: 22,
            height: 22,
            borderRadius: "50%",
            background: "#007bff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10,
            boxShadow: "0 1px 4px rgba(0,0,0,0.3)"
          }}>
            <span style={{ color: "#fff", fontSize: 13, fontWeight: "bold", lineHeight: 1 }}>✓</span>
          </div>
        )}

        {/* Blue Overlay */}
        {isSelected && (
          <div style={{
            position: "absolute",
            top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(0, 123, 255, 0.08)",
            borderRadius: 4,
            zIndex: 5,
            pointerEvents: "none"
          }} />
        )}

        <img
          src={asset.filePath}
          alt="not found"
          width="100%"
          height="100%"
        />

        <p
          className="text-center mt-2"
          title={asset.fileName}
          style={{
            fontSize: "13px",
            fontWeight: isSelected ? "600" : "400",
            color: isSelected ? "#007bff" : "#333",
          }}
        >
          {asset.fileName.length > 30
            ? `${asset.fileName.substring(0, 30)}...`
            : asset.fileName}
        </p>
      </Card>
    );
  })()}
</Col>
          ))) : (
          <Col xs={12}>
            <div className="text-center py-5">
              <h5>No Image Found</h5>
            </div>
          </Col>
        )}
      </Row>

    </>
  )
}
export default AssetsgalleryImges